module.exports = __webpack_public_path__ + "static/banquet01-97a1185f7d175c967d0f7332f8e7f876.jpg";